import { render, staticRenderFns } from "./ProductVariant.vue?vue&type=template&id=9a1cb4ae&scoped=true&"
import script from "./ProductVariant.vue?vue&type=script&lang=ts&"
export * from "./ProductVariant.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a1cb4ae",
  null
  
)

export default component.exports